<template>
	<div class="px-2">
		<app-table
			class="mt-5 is-not-selectable"
			:current-page="currentPage"
			:last-page="lastPage"
			name="accounting-periods"
			:columns="columns"
			:filter-columns="false"
			:rows="rows"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search', $event)"
		>
			<template slot="rows" slot-scope="props">
				<template v-for="(prop, index) in columns">
					<td
						:key="prop.id"
						v-if="!prop.flagVisible"
						:class="{ 'is-not-selectable' : index === 0 }"
					>
						{{ props.row[prop.value] }}
					</td>
					<td
						:key="prop.id"
						v-else
					>
						<v-btn
							class="btn-action btn-auto btn-width-auto px-2 py-1"
							color="#02979b"
							small
							@click="$emit('add-record', props.row)"
						>
							<v-icon id="add-icon" color="white">add
							</v-icon>
						</v-btn>
					</td>
				</template>
			</template>
		</app-table>
	</div>
</template>

<script>

export default {
	name: 'searcher-list',
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		textBtn: {
			default: 'Agregar',
			type: String,
		},
	},
};
</script>
<style lang="scss" scoped>
	.select-btn {
		background-color: color(btn-green);
		border: none;
		border-radius: 20px;
		color: white;
		height: 21px;
		width: 93px;
	}
	.btn-action {
		height: 25px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/searcher/searcher-list.vue